export type CalendarSettingsType = "user" | "org" | "project"

export type CalendarSettingsId = `${CalendarSettingsType}_${string}`

export type CalendarSettingsIdInput = {
  type: CalendarSettingsType
  id: string
}

export const makeCalendarSettingsId = ({ type, id }: CalendarSettingsIdInput): CalendarSettingsId => {
  return `${type}_${id}`
}

export const makeCalendarSettingsIds = (inputs: CalendarSettingsIdInput[]): CalendarSettingsId[] => {
  return inputs.map(makeCalendarSettingsId)
}

export const makeCalendarSettingsSearchParams = (
  ids?: CalendarSettingsId[] | CalendarSettingsIdInput[]
): URLSearchParams => {
  const searchParams = new URLSearchParams()
  const calendarSettingsIds = ids?.map((id) => (typeof id === "string" ? id : makeCalendarSettingsId(id)))
  if (calendarSettingsIds?.length) {
    searchParams.append("ids", calendarSettingsIds.join(","))
  }
  return searchParams
}
